var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-spinner",class:_vm.size === 's' && 'small'}),(_vm.text)?_c('div',{staticClass:"loader-text",class:_vm.size === 's' && 'small'},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }